import type { PrescriptionT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { PRESCRIPTION_FIELD_LABELS } from '@/entities/rx';
import type { TableConfig } from '@/shared/lib/table';

export const PRESCRIPTIONS_TABLE_CONFIG: TableConfig<keyof PrescriptionT> = {
  columnOrder: [
    'DisplayName',
    'Status',
    'MedicationStatus',
    'WrittenDate',
    'EffectiveDate',
    'Quantity',
    'Refills',
  ],
  globalSearchKeys: ['DisplayName'],
  sortableColumns: ['Status', 'MedicationStatus', 'WrittenDate', 'EffectiveDate'],
  badgeColumns: ['Status', 'MedicationStatus'],
  headerByColumn: PRESCRIPTION_FIELD_LABELS,
};
